import numeral from 'numeral';

export const resultParser = {
    parse(results) {
        // round values according to type
        Object.keys(results).forEach(key => {
            results[key].value = this.round(results[key]);
        });
        return results;
    },
    round(result) {
        if (result.type === "days") {
            return Math.round(parseFloat(result.value));
        } else if (result.type === "currency") {
            return numeral(result.value).format('0,0.00');
        } else if (result.type === "percentage") {
            return parseFloat(result.value * 100).toFixed(2);
        }
    }
}
